"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Search, Sparkles, Megaphone, Share2, MessageSquare, Globe, Gift, Hand } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NosServices() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section4Ref,
    isVisible: section4Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section5Ref,
    isVisible: section5Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section6Ref,
    isVisible: section6Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section7Ref,
    isVisible: section7Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: section8Ref,
    isVisible: section8Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = [{
    icon: Search,
    title: "Référencement Google (SEO)",
    description: "Optimisez votre visibilité naturelle sur les moteurs de recherche avec nos stratégies SEO éprouvées."
  }, {
    icon: Sparkles,
    title: "Référencement IA générative",
    description: "Positionnez votre entreprise dans les réponses des intelligences artificielles comme ChatGPT et Gemini."
  }, {
    icon: Megaphone,
    title: "Google Ads",
    description: "Générez des leads qualifiés avec des campagnes publicitaires optimisées et un budget maîtrisé."
  }, {
    icon: Share2,
    title: "Gestion des réseaux sociaux",
    description: "Un outil pour planifier et multiposter sur 15 réseaux sociaux : Soit vous gérez, soit on gère pour vous avec votre aprobation."
  }, {
    icon: MessageSquare,
    title: "Campagnes SMS",
    description: "Touchez vos clients localement avec des campagnes SMS marketing ciblées et efficaces."
  }, {
    icon: Gift,
    title: "Goodies",
    description: "Marquez les esprits avec des objets publicitaires personnalisés de qualité pour fidéliser vos clients."
  }, {
    icon: Hand,
    title: "Distribution de flyers",
    description: "Campagnes de street marketing ciblées pour capter l'attention de vos prospects directement sur le terrain."
  }];
  const refs = [section1Ref, section2Ref, section3Ref, section4Ref, section5Ref, section6Ref, section7Ref];
  const visibilities = [section1Visible, section2Visible, section3Visible, section4Visible, section5Visible, section6Visible, section7Visible];
  return <section id="nos-services" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Nos services
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto">
            Des solutions complètes pour développer votre visibilité digitale et générer des leads qualifiés
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-slow)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-muted-light-background border border-border hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] cursor-pointer">
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                        <Icon className="w-6 h-6 text-foreground" strokeWidth={2} />
                      </div>
                      <div className="flex-1">
                        <CardTitle className="text-xl font-semibold text-foreground mb-2">
                          {service.title}
                        </CardTitle>
                        <CardDescription className="text-muted-foreground leading-relaxed">
                          {service.description}
                        </CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                </Card>
              </div>;
        })}

          <div ref={section8Ref} data-index={7} className={`md:col-span-2 transition-all duration-[var(--duration-slow)] ${section8Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "700ms"
        }}>
            <Card className="bg-muted-light-background border border-border hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] cursor-pointer">
              <CardHeader>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Globe className="w-6 h-6 text-foreground" strokeWidth={2} />
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-xl font-semibold text-foreground mb-2">
                      Création de sites WordPress
                    </CardTitle>
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      Site web clé en main, optimisé SEO et mobile. Vous restez propriétaire de votre site et de votre nom de domaine avec un accès complet.
                    </CardDescription>
                  </div>
                </div>
              </CardHeader>
            </Card>
          </div>
        </div>

        <div className="mt-12 flex justify-center">
          <Button onClick={() => document.getElementById('demandez-votre-devis')?.scrollIntoView({
          behavior: 'smooth'
        })} className="btn-primary">
            Obtenir un devis gratuit
          </Button>
        </div>
      </div>
    </section>;
}